import type { IconSvgObject } from './types';

const UserWarning03Icon: IconSvgObject = [
  ["path", { d: "M15.5 7C15.5 9.20914 13.7091 11 11.5 11C9.29086 11 7.5 9.20914 7.5 7C7.5 4.79086 9.29086 3 11.5 3C13.7091 3 15.5 4.79086 15.5 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 6V10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19.5 13V13.01", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M18.5 19C18.5 16.2386 16.2614 14 13.5 14H9.5C6.73858 14 4.5 16.2386 4.5 19V20C4.5 20.5523 4.94772 21 5.5 21H17.5C18.0523 21 18.5 20.5523 18.5 20V19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default UserWarning03Icon;
